import 'slick-carousel';

$('.slider-products').each(function() {
  sliderInit($(this));
});

function sliderInit($this) {
  $this.find('.slider__slides').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: true,
    infinite: true,
    prevArrow: $this.find('.slider__nav-prev'),
    nextArrow: $this.find('.slider__nav-next'),
    appendDots: $this.find('.slider__nav'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
}

if ($('#recommended-products').length) {
  const targetNode = document.getElementById('recommended-products');
  const config = { attributes: true, childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      sliderInit($('#recommended-products'));
      observer.disconnect();
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
